import styled, {css} from "styled-components"

import {minWidthMedia} from "@irati/ui/src/global/media"
import {H4, H5} from "@irati/ui/src/Typography"
import {singleLine as singleLineEllipsis} from "@irati/ui/src/global/css/multiLineEllipsis"

interface ResponsiveSavingWrapperProps {
  isFullPage: boolean,
  isCompact: boolean
}

export const ResponsiveSavingWrapper = styled.div<ResponsiveSavingWrapperProps>`
  ${({isCompact, isFullPage, theme}) => css`
    ${isCompact && "text-align: center;"}
    ${theme.mediaQueries.minWidthMedia.desktop`
      ${isFullPage && "display: none;"}
    `} 
  `}
`

export const H4Title = styled(H4)`
  min-height: 36px;
  ${singleLineEllipsis};

  text-align: left;
  ${minWidthMedia.tablet`
    min-height: 46px;
  `}
`

export const H5Title = styled(H5)`
  min-height: 36px;
  text-align: center;
  ${singleLineEllipsis}

  ${minWidthMedia.tablet`
    min-height: 46px;
  `}
`
